import { createGlobalStyle } from "styled-components"
import safWebfontWoff2 from "../../static/fonts/saf-webfont.woff2"
import safWebfontWoff from "../../static/fonts/saf-webfont.woff"
import Typography from "../components/Typography"
import theme from "./theme"
import vSpacing from "./vSpacing"
import breakpoints from "./breakpoints"

const { H800, H700, H600, H500, H400, H300, H200, H300Semibold } = Typography

const GlobalStyle = createGlobalStyle`
  body {
    @font-face {
    font-family: 'SAF';
        src: url(${safWebfontWoff2}) format('woff2'),
          url(${safWebfontWoff}) format('woff');
        font-display: swap;
    }
  }
  html {
    font-size: 10px;
    ${breakpoints.md`
      font-size: 16px;
  `};
  }
  html,
  body {
    min-height: 100%;
    width: 100%;
  }

  body {
    background-color: white !important;
    margin: 0;
    padding: 0;
    @font-face {
      font-family: 'Montserrat', sans-serif;
      font-display: swap;
    }

    font-size: 12px;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.67;
    letter-spacing: normal;
  }

  #root {
    display: flex;
    flex-direction: column;
    min-height: 100%;
    width: 100%;
  }

  *, *:before, *:after {
    box-sizing: border-box;
  }
  a {
    ${H200}
    text-decoration: none;
    transition: color 0.2s ease-in;
    &:focus {
      outline: none;
    }
    &.normalLink {
      ${H300}
      &:focus {
        outline: none;
      }
      display: inline-block;
      border-bottom: solid 3px ${theme.colors.orange800};
      transition: ${theme.transitions.hover};
        &:hover {
          border-bottom-width: 5px;
          margin-bottom: -2px;
        }
      }
  }

  .normal-links {
    a {
    ${H200}
    &:focus {
      outline: none;
    }
    display: inline-block;
    border-bottom: solid 3px ${theme.colors.orange800};
    transition: ${theme.transitions.hover};
      &:hover {
        border-bottom-width: 5px;
        margin-bottom: -2px;
      }
    }
  }

  p {
    font-weight: normal;

  }

  h1, h2, h3, h4, h5, p {
    margin: 0;
  }

  h1, h2, h3, h4, h5 {
    word-wrap: break-word;
    overflow-wrap: break-word;
    hyphens: auto;
  }

  h1 {
    ${H800}
  }

  h2 {
    ${H700}
  }

  h3 {
    ${H600}
  }

  h4 {
    ${H500}
  }

  h5 {
    font-weight: 600 !important;
    ${H400}
  }

  h6 {
    ${H300}
  }

  p {
    ${H300}
    margin: 4px 0;
  }

  label, input {
    font-family: ${theme.font.secondary} !important;
  }

  strong {
    ${H300Semibold}
    margin: 4px 0;
  }

  ul {
    ${H300}
    list-style: none;
    margin-left: 16px;
    padding-left: 16px;
    li {
      margin-bottom: ${vSpacing.baseX3};
      text-indent: -16px;
      &:last-child {
        margin-bottom: 0;
      }
      &::before{
        content: "";
        color: ${theme.colors.yellow800};
        background: url("data:image/svg+xml,%3csvg height='10' width='10' viewBox='0 0 41 42' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M27.80899618 36.45493182c3.68051843-3.02492248 8.57455227-4.95308003 11.43401744-8.53821306 3.09671405-3.88259053.43131794-11.61030361-2.5269845-16.73423376-3.1887174-5.52302055-7.0180972-8.85242612-12.89135498-9.9711136C19.84685252.45371027 12.9096617-.1781111 8.9933385 1.67572294 1.30006072 5.31741934-.3907595 13.0598238 1.11600227 21.65074538c.392786 2.23950059-.75426243 7.92387138 3.16221116 13.1370919 6.42394038 8.55091118 14.66889353 8.95045122 23.53078275 1.66709454z' fill='%23fec20d' fillRule='evenodd'/%3e%3c/svg%3e");
        background-repeat: no-repeat;
        height: 10px;
        width: 10px;
        background-position: center;
        background-size: 100%;
        display: inline-block;
        margin-right: 16px;
        margin-left: -10px;
      }
      & > * {
        text-indent: 0;
      }
    }
  }
  }

  .lga-bottom-border-white {
    /* Custom LGA bottom border */
    &:after {
      content: '';
      position: absolute;
      top: 100%;
      left: 0;
      height: 38px;
      margin-top: -38px;
      width: 100%;
      background: url("data:image/svg+xml,%3csvg width='320' height='57' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M0 57V23.021c2.1872-.6288 4.6982-1.4944 6.8843-2.4181 2.6457-1.0997 6.0011-2.0994 7.4207-2.0994s7.098-1.7994 12.5183-3.8987c5.4204-2.0993 15.8093-3.299 22.9073-2.4992 7.098.7998 14.0025 1.1996 15.2285.7998 1.226-.3 10.8406-.4999 21.2941-.3 27.8114.4999 27.7468.4999 40.007-.8996 16.0029-1.7995 22.3911-1.7995 25.2303.1 1.8713 1.2995 4.0653 1.5994 10.647 1.2995 4.5815-.2 9.163-.8997 10.1309-1.4995 1.2905-.7998 6.969-.9997 17.616-.6998 9.0339.3 16.519.1 17.5515-.4998.968-.4999 4.3879-1.0997 7.5497-1.3996 8.3886-.5998 11.5504-1.1996 17.616-3.3989 3.549-1.2995 6.5818-1.6994 8.8403-1.3995 2.323.3999 4.4524 0 6.84-1.2996 3.0327-1.4995 5.4848-1.7994 18.0031-1.5995 8.0014.1 16.261-.2999 18.3258-.7997 3.1619-.7998 4.0653-.6998 4.9686.5998.8389 1.0996 2.5811 1.4995 7.3562 1.4995 4.0007 0 6.9044.3999 8.0014 1.2996.9034.7997 3.7426 1.6994 6.1946 1.9993 1.6087.1917 5.0368.6694 8.8684 1.198V57H0z' fill='%23ffffff' fill-rule='evenodd'/%3e%3c/svg%3e") top center;
      background-size: cover;
      background-repeat: no-repeat;
    }
    ${breakpoints.md`
      &:after {
        background: url("data:image/svg+xml,%3csvg width='1440' height='46' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M0 46V13.324c.8707.0462 1.8988.2876 2.749.6851 1.8047.791 10.5276 1.0284 37.8994.9493 19.5514 0 38.2003-.2374 41.509-.5538 3.3087-.2373 9.1741-.712 13.0844-1.0283 4.0606-.2374 9.6252-1.3448 12.4827-2.3732 3.008-1.0283 6.9182-1.8985 8.723-1.8985 1.8047 0 7.0685-.5537 11.5803-1.2657 7.5198-1.1074 44.3665-3.006 54.7438-2.7686 2.4063 0 5.1134.3955 6.0158.8701.752.3955 3.9102.791 6.9181.791 6.7678 0 27.0711 2.5314 37.298 4.6672 4.3614.9493 9.4748 1.6612 11.2796 1.6612 1.8047 0 5.2638.5538 7.6701 1.1866 2.4063.6329 7.0686 1.4239 10.5277 1.6612 3.3086.3164 7.0685.8702 8.1213 1.3448 1.2031.4746 2.4063.4746 3.7599 0 .9023-.4746 4.211-.6328 7.0685-.3955s10.678.4746 17.2954.5537c12.7836.2373 30.5302 1.0284 32.1845 1.503 1.6544.4746 17.145-.9493 28.7254-2.6105 6.1662-.8701 13.9868-1.6612 17.2955-1.6612 3.3086 0 16.5434-1.4238 29.1766-3.085l23.1608-3.1642 30.2293 1.1865c16.5435.6329 32.6357.9493 35.4932.6329 2.8575-.2373 25.2664-.3956 49.6303-.2373 64.8202.3955 64.6698.3955 93.2449-.712 37.2979-1.4239 52.187-1.4239 58.8043.0791 4.3615 1.0284 9.475 1.2657 24.8152 1.0284 10.678-.1582 21.356-.712 23.612-1.1866 3.0079-.6328 16.2426-.791 41.0578-.5537 21.0553.2373 38.501.079 40.9074-.3955 2.256-.3956 10.2268-.8702 17.5962-1.1075 19.5513-.4746 26.9207-.9493 41.0578-2.6896 8.2717-1.0283 15.3403-1.3448 20.604-1.1074 5.4143.3164 10.3773 0 15.942-1.0284 7.0685-1.1866 12.7835-1.4239 41.9601-1.2657 18.649.0791 37.8995-.2373 42.7122-.6328 7.3693-.6329 9.4748-.5538 11.5804.4746 1.9551.8702 6.0158 1.1866 17.145 1.1866 9.3245 0 16.0922.3164 18.649 1.0283 2.1055.6329 8.7228 1.3448 14.4379 1.5821 5.8653.2374 22.108 1.0284 36.0947 1.6612 40.9074 1.8986 53.3902 2.7687 65.4218 4.9045 6.1662 1.1075 12.7835 2.6896 14.5883 3.5597 2.7071 1.3448 4.5118 1.5821 10.5276 1.1866 3.9103-.3164 13.9868-.712 22.2585-.9492 8.2717-.2374 21.9576-1.424 30.5301-2.5314 12.934-1.6612 16.0923-1.8985 19.401-1.1075 2.5567.6329 12.3323.9493 27.9734.9493 13.2348-.0791 24.8152.2373 25.7175.6328 1.504.6329 20.7545-.079 30.5302-1.1074 2.256-.2373 11.1292-.3956 19.5513-.3956 9.7757 0 17.7466-.3955 21.8073-1.1074 3.459-.712 6.7677-.9493 7.219-.6329.5762.4547 11.3635.4738 39.6315.1966V46H0z' fill='%23ffffff' fill-rule='evenodd'/%3e%3c/svg%3e") top center;
        background-size: cover;
        background-repeat: no-repeat;
      }
    `};
  }
`
export default GlobalStyle
